import type { AppointmentFormState } from '../useAppointmentForm';

interface Props {
  state: AppointmentFormState;
}

/**
 * Task #2786 — Selettore sede in testa al flusso di prenotazione.
 *  - Quando il form consente la scelta sede (`allowStoreChoice`), mostra le
 *    sedi attive del tenant come pill selezionabili (sede obbligatoria).
 *  - Quando la scelta è disabilitata, mostra la sede di default in chiaro e
 *    non editabile, sempre visibile.
 *
 * Task #2841 — redesign in pill coerenti col flusso verticale + token aw-*
 * REALI (`--aw-card`/`--aw-card-hover`/`--aw-fg`/`--aw-border`/`--aw-muted`/
 * `--aw-primary`): le precedenti `--aw-muted-bg`/`--aw-text` non esistono e in
 * dark mode rendevano la sede di default illeggibile.
 */
export default function StoreSelector({ state }: Props) {
  const { config, selectedStoreId, selectStore } = state;
  if (!config) return null;

  if (config.allowStoreChoice && config.stores.length > 0) {
    return (
      <section className="aw-flow-section">
        <h3 className="aw-section-title">Sede *</h3>
        <div className="aw-store-grid" role="radiogroup" aria-label="Sede">
          {config.stores.map((s) => {
            const isSelected = selectedStoreId === s.id;
            return (
              <button
                key={s.id}
                type="button"
                role="radio"
                aria-checked={isSelected}
                className={`aw-store-pill ${isSelected ? 'aw-selected' : ''}`}
                onClick={() => selectStore(s.id)}
              >
                <span className="aw-store-name">{s.name}</span>
                {s.city && <span className="aw-store-city">{s.city}</span>}
              </button>
            );
          })}
        </div>
      </section>
    );
  }

  if (!config.allowStoreChoice && config.defaultStore) {
    const ds = config.defaultStore;
    return (
      <section className="aw-flow-section">
        <h3 className="aw-section-title">Sede</h3>
        <div className="aw-store-readonly">
          <span className="aw-store-name">{ds.name}</span>
          {ds.city && <span className="aw-store-city">{ds.city}</span>}
        </div>
      </section>
    );
  }

  return null;
}
